/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import { Headline, Subheading, Title } from "@itwin/itwinui-react";
import classNames from "classnames";
import React from "react";
import { Helmet } from "react-helmet-async";
import sanitizeHtml from "sanitize-html";
import styles from "./FallbackUi.module.scss";
export const FallbackUi = ({ imageSource, imageAlt, className, title, text, withHelmet, }) => {
    const innerText = sanitizeHtml(text);
    return (React.createElement("div", { className: classNames(styles.container, className) },
        withHelmet && React.createElement(Helmet, { title: title }),
        React.createElement("div", { className: styles.content },
            React.createElement("img", { src: imageSource, alt: imageAlt, "data-testid": "test-fallback-img" }),
            React.createElement(Headline, { className: styles.title, "data-testid": "test-fallback-title" },
                React.createElement(Title, null, title)),
            React.createElement(Headline, { className: styles.message, "data-testid": "test-fallback-text" },
                React.createElement(Subheading, { dangerouslySetInnerHTML: { __html: innerText } })))));
};
